import React from 'react';

const StepIndicator = ({ currentStep, isSuccess }) => {
  if (isSuccess) return null;

  const steps = [1, 2, 3];

  return (
    <div className="flex items-center justify-center mb-6">
      {steps.map((step) => (
        <div key={step} className="flex items-center">
          <div
            className={`w-5 h-5 rounded-full flex items-center justify-center text-xs transition-colors ${
              currentStep >= step
                ? 'bg-emerald-500 text-white'
                : 'bg-neutral-700 text-neutral-500'
            }`}
          >
            {step}
          </div>
          {step < 3 && (
            <div
              className={`w-10 h-px mx-1 transition-colors ${
                currentStep > step ? 'bg-emerald-500' : 'bg-neutral-700'
              }`}
            />
          )}
        </div>
      ))}
    </div>
  );
};

export default StepIndicator;
